import React from "react";
import BaseButton from "../Base/BaseButton/BaseButton";
import "./SearchBar.css";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onSearch?: () => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onSearch,
  placeholder = "Search...",
}) => {

  return (
    <div className="search-bar" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="search-input"
      />
      <BaseButton variant="secondary" onClick={onSearch} type="button">
        Search
      </BaseButton>
    </div>
  );
};

export default SearchBar;
